module.exports = __webpack_public_path__ + "img/partners_logo_new.0dc7e287.png";